import React, { useEffect } from 'react';
import { Container } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import '../Features.css';

const Features = () => {
  const { t } = useTranslation();
  useEffect(() => {
    document.getElementById('home').classList.add('featureContent');
    return () => {
      document.getElementById('home').classList.remove('featureContent');
    };
  });
  useEffect(() => {
    setTimeout(() => {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }, 100);
  }, []);
  return (
    <Container className="featureContainer">
      <div className="container">
        <h2 className="headerTitle">{t('contents:featuresTitle')}</h2>

        <p>{t('contents:featuresParagraph1')}</p>
        <p>{t('contents:featuresParagraph2')}</p>
        <p>{t('contents:featuresParagraph3')}</p>
        <h2>{t('contents:featuresHeader1')}</h2>
        <p>{t('contents:featuresParagraph4')}</p>
        <p>{t('contents:featuresParagraph5')}</p>
        <img
          src={require('../../../assets/images/features/vibino-feature- photo straighten-pic1.jpg')}
        />
        <h2>{t('contents:featuresHeader2')}</h2>
        <p>{t('contents:featuresParagraph6')}</p>
        <img
          src={require('../../../assets/images/features/vibino-feature- photo straighten-pic2.jpg')}
        />
        <h2>{t('contents:featuresHeader3')}</h2>
        <p>{t('contents:featuresParagraph7')}</p>
        <img src={require('../../../assets/images/features/vibino-feature-Add text-pic1.jpg')} />
        <h2>{t('contents:featuresHeader4')}</h2>
        <p>{t('contents:featuresParagraph8')}</p>
        <img
          src={require('../../../assets/images/features/vibino-feature-speech bubble-pic1.jpg')}
        />
        <h2>{t('contents:featuresHeader5')}</h2>
        <p>{t('contents:featuresParagraph9')}</p>
        <img src={require('../../../assets/images/features/vibino-feature-Transparent-pic1.jpg')} />

        <h2>{t('contents:featuresHeader6')}</h2>
        <p>{t('contents:featuresParagraph10')}</p>
        <img
          src={require('../../../assets/images/features/vibino-feature-photo effect-pic1.jpg')}
        />

        <h2>{t('contents:featuresHeader7')}</h2>
        <p>{t('contents:featuresParagraph11')}</p>
        <img src={require('../../../assets/images/features/vibino-feature-blur photo-PIC1.jpg')} />

        <h2>{t('contents:featuresHeader8')}</h2>
        <p>{t('contents:featuresParagraph12')}</p>
        <img
          src={require('../../../assets/images/features/vibino-feature-photo effect-PIC2.jpg')}
        />

        <h2>{t('contents:featuresHeader9')}</h2>
        <p>{t('contents:featuresParagraph13')}</p>
        <img src={require('../../../assets/images/features/vibino-feature-image grid-pic1.jpg')} />

        <h2>{t('contents:featuresHeader10')}</h2>
        <p>{t('contents:featuresParagraph14')}</p>
        <img src={require('../../../assets/images/features/vibino-feature-Icon-pic1.jpg')} />

        <h2>{t('contents:featuresHeader11')}</h2>
        <p>{t('contents:featuresParagraph15')}</p>
        <img src={require('../../../assets/images/features/vibino-feature-image Grid-pic2.jpg')} />

        <h2>{t('contents:featuresHeader12')}</h2>
        <p>{t('contents:featuresParagraph16')}</p>
        <img src={require('../../../assets/images/features/vibino-feature-Add text-pic2.jpg')} />

        <h2>{t('contents:featuresHeader13')}</h2>
        <p>{t('contents:featuresParagraph17')}</p>
        <img
          src={require('../../../assets/images/features/vibino-feature-Add stickers-pic1.jpg')}
        />

        <h2>{t('contents:featuresHeader14')}</h2>
        <p>{t('contents:featuresParagraph18')}</p>
        <img
          src={require('../../../assets/images/features/vibino-feature-photo effect-PIC3.jpg')}
        />

        <h2>{t('contents:featuresHeader15')}</h2>
        <p>{t('contents:featuresParagraph19')}</p>
        <img src={require('../../../assets/images/features/vibino-feature-icon-pic4.jpg')} />
      </div>
    </Container>
  );
};

export default Features;
